<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside mb-3" style="top: 120px;">
                            <!-- Profile Sidebar -->
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><customer-sidebar></customer-sidebar></div>
                            <!-- /Profile Sidebar -->
                        </div>
                    </div>
                    <!-- / Profile Sidebar -->

                    <div class="col-12 col-xl-9">
                        <div class="d-sm-flex d-block justify-content-between align-items-center border-bottom mb-4">
                            <h2>Détails Match</h2>
                        </div>

                        <div class="d-flex justify-content-around align-items-top py-4">
                            <div class="mt-3 text-center w-100" style="max-width: 30%;">
                                <figure class="bg-white rounded-xl p-3 mb-2 border mx-auto" style="width: fit-content;">
                                    <img :src="match.team_a?.logo || defaultTeamLogoPath" width="60px" class="h-auto">
                                </figure>
                                <span class="d-block mb-3">{{ match.team_a?.name }}</span>
                            </div>
                            <div class="mx-2 d-flex flex-column justify-content-start align-items-center">
                                <span class="text-muted text-center mb-3">{{ formatDateTime(match.booking?.start_time).datetime }}</span>
                                <span class="font-weight-bold">
                                    <span class="h1" v-if="match.status === 'completed' && match.score_submitted_at">{{ match.score_a }}</span>
                                    <input type="number" v-if="match.status === 'completed' && !match.score_submitted_at" class="form-control form-control-sm d-inline-block" style="width: 55px; padding: 6px;" min="0" v-model="match.score_a"/>
                                    <b class="h1 mx-1">-</b>
                                    <input type="number" v-if="match.status === 'completed' && !match.score_submitted_at" class="form-control d-inline-block" style="width: 55px; padding: 6px;" min="0" v-model="match.score_b"/>
                                    <span class="h1" v-if="match.status === 'completed' && match.score_submitted_at">{{ match.score_b }}</span>
                                </span>
                                <div v-if="showLiveMinute" class="live-minute-badge my-3">{{ liveMinute }}'</div>
                                <div v-else class="d-flex align-items-center mt-2">
                                    <span class="badge badge-pill text-xs py-1 px-2" 
                                        :class="match.status === 'draft' ? 'bg-secondary-light'
                                        : match.status === 'scheduled' ? 'bg-info-light'
                                        : match.status === 'completed' ? 'bg-success-light'
                                        : match.status === 'cancelled' ? 'bg-danger-light'
                                        : 'bg-warning-light'"
                                    >
                                        {{ statuses[match.status]?.label }}
                                    </span>
                                </div>
                                <div class="d-flex flex-column mt-4">
                                    <a href="javascript:void(0)" v-if="match.status == 'scheduled' && (canEditTeamA || canEditTeamB || currentUser.id === match.booking?.user_id)" class="btn btn-sm btn-info text-xs mb-1" @click="saveMatch()">
                                        Sauvegarder
                                    </a>
                                    <!-- <a href="javascript:void(0)" v-if="notStartedYet(match) && match.status == 'draft' && match.team_a && match.team_b && currentUser.id === match.booking?.user_id" class="btn btn-sm btn-warning text-xs" 
                                        @click="schedule()">
                                        Organiser
                                    </a> -->
                                    <a href="javascript:void(0)" v-if="match.status == 'scheduled' && currentUser.id === match.booking?.user_id" class="btn btn-sm btn-danger text-xs" 
                                        @click="cancel()">
                                        Annuler
                                    </a>
                                </div>
                                <div class="d-flex flex-column text-center align-items-center justify-content-center mt-3" v-if="match.status === 'completed'">
                                    <div class="d-flex gap-2 align-items-center justify-content-center">
                                        <button class="btn btn-sm btn-primary mx-1" v-if="canEditTeamA && !match.score_submitted_at" @click="submitScore()">Soumettre le score</button>
                                        <button class="btn btn-sm btn-success mx-1" v-if="canEditTeamB && !match.score_confirmed_at" @click="confirmScore()">Confirmer le score</button>
                                    </div>
                                    <div class="mb-2">
                                        <small class="text-muted">Soumis: {{ match.score_submitted_at ? formatDateTime(match.score_submitted_at).datetime : '-' }}</small>
                                        <br/>
                                        <small class="text-muted">Confirmé: {{ match.score_confirmed_at ? formatDateTime(match.score_confirmed_at).datetime : '-' }}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3 text-center w-100" style="max-width: 30%;">
                                <figure class="bg-white rounded-xl p-3 mb-2 border mx-auto" style="width: fit-content;">
                                    <img :src="match.team_b?.logo || defaultTeamLogoPath" width="60px" class="h-auto">
                                </figure>
                                <span class="d-block mb-3">{{ match.team_b?.name }}</span>
                            </div>
                        </div>

                        <div v-if="match.status === 'challenged'" class="rounded-xl border bg-light p-3 mb-4">
                            <div class="d-flex justify-content-between align-items-center flex-wrap mb-3">
                                <div>
                                    <h5 class="mb-1">Défi en cours</h5>
                                    <p class="text-sm text-muted mb-0">Ce défi expire automatiquement 45 minutes après sa création.</p>
                                </div>
                                <span :class="match.challenge_status === 'pending' ? 'bg-warning-light' : match.challenge_status === 'countered' ? 'bg-info-light' : match.challenge_status === 'accepted' ? 'bg-success-light' : 'bg-danger-light'" class="badge badge-pill text-xs py-1 px-2">
                                    {{ challengeStatuses[match.challenge_status]?.label || match.challenge_status }}
                                </span>
                            </div>

                            <div v-if="match.challenge_status === 'pending' && match.booking_id && (!match.suggestions || match.suggestions.length === 0) && canEditTeam(match.team_b)" class="d-flex justify-content-end mb-3">
                                <button class="btn btn-sm btn-outline-danger mr-2" @click="respondToChallenge('declined')">Refuser</button>
                                <button class="btn btn-sm btn-success" @click="respondToChallenge('accepted')">Accepter</button>
                            </div>

                            <div v-if="match.challenge_status === 'pending' && match.suggestions && match.suggestions.length > 0 && canEditTeam(match.team_b)" class="d-flex justify-content-end mb-3">
                                <a href="javascript:void(0)" class="btn btn-sm btn-outline-info" data-toggle="modal" data-target="#counterSuggestionModal" @click="openCounterSuggestionForm()">
                                    Contre-proposer
                                </a>
                            </div>

                            <div class="row">
                                <div v-for="suggestion in match.suggestions" :key="suggestion.id" class="col-md-4 mb-2">
                                    <div class="border rounded-lg bg-white p-3 h-100">
                                        <div class="d-flex justify-content-between align-items-start mb-2">
                                            <strong class="text-sm">Proposition {{ suggestion.sequence }}</strong>
                                            <span :class="proposalStatuses[suggestion.status]?.class || 'bg-warning-light'" class="badge badge-pill text-xs py-1 px-2">
                                                {{ proposalStatuses[suggestion.status]?.label || suggestion.status }}
                                            </span>
                                        </div>
                                        <div class="d-flex justify-content-start align-items-center mb-2">
                                            <img :src="(suggestion.booking?.slot.facility.establishment.logo_url || suggestion.slot?.facility?.establishment?.logo_url) || defaultTeamLogoPath" class="mr-2 p-2 bg-white rounded-lg" style="width: 40px;height: 40px;"/>
                                            <div class="d-flex flex-column">
                                                <span class="text-sm">Terrain {{ suggestion.booking?.slot.facility.name || suggestion.slot?.facility?.name }}</span>
                                                <span class="text-muted text-xs">{{ suggestion.booking?.slot.facility.establishment.business_name || suggestion.slot?.facility?.establishment?.business_name }}</span>
                                            </div>
                                        </div>
                                        <div class="text-sm">
                                            {{ formatDateTime(suggestion.booking?.start_time || suggestion.slot?.start_time).date }}
                                            <span class="d-block text-muted text-xs">{{ formatDateTime(suggestion.booking?.start_time || suggestion.slot?.start_time).time }} - {{ formatDateTime(suggestion.booking?.end_time || suggestion.slot?.end_time).time }}</span>
                                        </div>
                                        <div v-if="(match.challenge_status === 'pending' && canEditTeam(match.team_b) && suggestion.challenge_round === 1) || (match.challenge_status === 'countered' && canEditTeam(match.team_a) && suggestion.challenge_round === 2)" class="d-flex justify-content-end mt-3">
                                            <button class="btn btn-sm btn-outline-danger mr-2" @click="respondToChallenge('declined')">Rejeter</button>
                                            <button class="btn btn-sm btn-success" @click="respondToChallenge('accepted', suggestion.id)">Accepter</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-content mb-5 pb-3">
                            <ul class="nav nav-tabs nav-tabs-bottom nav-justified mb-4" style="border-bottom: 1px solid #dee2e6">
                                <li class="nav-item" v-if="showResumeTab">
                                    <a class="nav-link" :class="{ active: activeTab === 'summary' }"
                                        @click="this.activeTab='summary'" href="javascript:void(0)">Resumé</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" :class="{ active: activeTab === 'general' }"
                                        @click="this.activeTab='general'" href="javascript:void(0)">Informations</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" :class="{ active: activeTab === 'formation' }"
                                        @click="this.activeTab='formation'" href="javascript:void(0)">Compositions</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" :class="{ active: activeTab === 'h2h' }"
                                        @click="this.activeTab='h2h'" href="javascript:void(0)">Tête-à-tête</a>
                                </li>
                            </ul>
                            <div v-if="activeTab === 'summary' && showResumeTab" class="tab-pane fade show active">
                                <div>
                                    <div v-if="orderedMatchActions.length === 0" class="text-center text-sm text-muted py-4">Aucune action.</div>
                                    <div v-else class="border rounded-lg bg-white px-3 py-2">
                                        <div
                                            v-for="item in orderedMatchActions"
                                            :key="item.id"
                                            class="summary-event border-bottom py-2"
                                            :class="item.team_id === match.team_b_id ? 'summary-event-right' : 'summary-event-left'"
                                        >
                                            <div class="summary-event-minute text-muted text-xs">{{ item.minute ? `${item.minute}'` : '-' }}</div>
                                            <div class="summary-event-marker">
                                                <span class="action-marker" :class="actionTypeTone(item.action_type)">
                                                    <span class="material-symbols-outlined action-marker-icon">{{ actionTypeIcon(item.action_type) }}</span>
                                                </span>
                                            </div>
                                            <div class="summary-event-copy">
                                                <div class="text-sm font-weight-medium">{{ actionTypeLabel(item.action_type) }}</div>
                                                <div class="text-xs text-muted">{{ item.player?.name || '-' }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="activeTab === 'general'" class="tab-pane fade show active">
                                <table class="table table-striped table-borderless text-sm">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="d-flex align-items-center">
                                                    <span class="material-symbols-outlined font-size-1 mr-2">stadium</span>
                                                    Terrain
                                                </div>
                                            </td>
                                            <td class="text-right">
                                                <b>Terrain {{ displayFacilityName(match) }}</b>
                                                <span class="ml-1">({{ displayEstablishmentName(match) }})</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div class="d-flex align-items-center">
                                                    <span class="material-symbols-outlined font-size-1 mr-2">location_on</span>
                                                    Adresse
                                                </div>
                                            </td>
                                            <td class="text-right">
                                                {{ displayDelegation(match) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div class="d-flex align-items-center">
                                                    <span class="material-symbols-outlined font-size-1 mr-2">groups</span>
                                                    Capacité
                                                </div>
                                            </td>
                                            <!-- <td class="text-right font-weight-bold" v-if="notStartedYet(match) && currentUser.id === match.booking.user_id">
                                                {{ match.booking?.slot.facility.capacity / 2 }}v{{ match.booking?.slot.facility.capacity / 2 }}
                                                <select class="custom-select custom-select-sm" v-model="">
                                                    <option></option>
                                                </select>
                                            </td> -->
                                            <td class="text-right font-weight-bold">
                                                <span v-if="matchCapacitySlots">{{ matchCapacitySlots }}v{{ matchCapacitySlots }}</span>
                                                <span v-else>-</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="activeTab === 'formation'" class="tab-pane fade show active">
                                <div v-if="!matchCapacitySlots" class="alert alert-light border text-sm">
                                    Les détails terrain/capacité ne sont pas encore disponibles pour ce défi.
                                </div>
                                <table class="table table-striped table-borderless text-sm">
                                    <thead class="thead-light">
                                        <tr>
                                            <th class="w-25 align-middle-important">
                                                <select v-if="notStartedYet(match) && [match.team_a?.owner_id, match.team_a?.captain_id].includes(player.id)" 
                                                    class="custom-select-sm custom-select w-auto" v-model="match.team_a_formation">
                                                    <option v-for="formation in possibleFormations" :value="formation">{{ formation }}</option>
                                                </select>
                                                <span v-else>{{ match.team_a_formation }}</span>
                                            </th>
                                            <th class="text-center align-middle-important">Formation</th>
                                            <th class="w-25 text-right align-middle-important">
                                                <select v-if="notStartedYet(match) && [match.team_b?.owner_id, match.team_b?.captain_id].includes(player.id)" 
                                                    class="custom-select-sm custom-select w-auto" v-model="match.team_b_formation">
                                                    <option v-for="formation in possibleFormations" :value="formation">{{ formation }}</option>
                                                </select>
                                                <span v-else>{{ match.team_b_formation }}</span>
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                                <div class="bg-light rounded-lg p-2 my-2">
                                    <div class="bg-cover d-flex justify-content-between mx-auto my-2" style="max-width: 500px; width:100%; aspect-ratio: 3 / 2;" :style="'background-position: center;background-image: url('+require('@/assets/img/pitch.png')+');'">
                                        <div class="w-50 h-100 d-block py-3 pl-3">
                                            <div class="w-100 h-100 d-flex" v-if="match.team_a_formation">
                                                <div class="w-25 h-100 d-flex flex-column justify-content-around" v-for="(total, index) in ('1-'+match.team_a_formation).split('-')">
                                                    <span class="bg-white rounded-sm shadow" style="height: fit-content;width: fit-content;" v-for="pos in parseInt(total)">
                                                        <span class="badge p-2" :class="startingPositions[formationPositions[index]]['class']" style="min-width: 34px;height: fit-content;">
                                                            {{ startingPositions[formationPositions[index]]['abbr'] }}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-50 h-100 d-block py-3 pl-3">
                                            <div class="w-100 h-100 d-flex" v-if="match.team_b_formation">
                                                <div class="w-25 h-100 d-flex flex-column justify-content-around" v-for="(total, index) in ('1-'+match.team_b_formation).split('-').reverse()">
                                                    <span class="bg-white rounded-sm shadow" style="height: fit-content;width: fit-content;" v-for="pos in parseInt(total)">
                                                        <span class="badge p-2" :class="startingPositions[formationPositions[formationPositions.length-index-1]]['class']" style="min-width: 34px;height: fit-content;">
                                                            {{ startingPositions[formationPositions[formationPositions.length-index-1]]['abbr'] }}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <table class="table table-striped table-borderless text-sm">
                                    <thead class="thead-light">
                                        <tr>
                                            <th colspan="3" class="text-center">Titulaires</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-xs">
                                        <template v-for="(item, index) in matchCapacitySlots" :key="index">
                                            <tr>
                                                <td colspan="2" class="w-50" style="vertical-align: middle;">
                                                    <span class="d-flex align-items-center" v-if="startingTeamA[index]">
                                                        <span class="badge p-1 py-2 mr-2" v-if="startingTeamA[index].position" :class="startingPositions[startingTeamA[index].position]['class']" style="min-width: 25px;">
                                                            {{ startingPositions[startingTeamA[index].position]['abbr'] }}
                                                        </span>
                                                        <span class="d-flex align-items-center" v-if="startingTeamA[index].player_name">
                                                            <span>
                                                                {{ startingTeamA[index].player_name }}
                                                                <b v-if="match.team_a?.captain_id == startingTeamA[index].player_id">(C)</b>
                                                            </span>
                                                            <a href="javascript:void(0)" data-toggle="modal" data-target="#selectPlayerModal" @click="selectPlayerForSlot(match.team_a, index)" 
                                                                v-if="[match.team_a?.owner_id,match.team_a?.captain_id].includes(player.id) && match.status !== 'completed'"
                                                                class="btn btn-sm bg-light text-xs d-inline-flex h-auto align-items-center rounded-pill px-2 ml-2 shadow-sm">
                                                                <span class="material-symbols-outlined text-sm">swap_vert</span>
                                                            </a>
                                                        </span>
                                                        <span v-else-if="[match.team_a?.owner_id,match.team_a?.captain_id].includes(player.id)">
                                                            <a href="javascript:void(0)" data-toggle="modal" data-target="#selectPlayerModal" @click="selectPlayerForSlot(match.team_a, index)" 
                                                                class="btn btn-sm bg-light text-xs d-inline-flex h-auto align-items-center rounded-pill px-2 shadow-sm">
                                                                Sélectionner joueur
                                                            </a>
                                                        </span>
                                                        <span v-else>Poste non attribué</span>
                                                    </span>
                                                </td>
                                                <td class="w-50 text-right" style="vertical-align: middle;">
                                                    <span class="d-flex align-items-center justify-content-end" v-if="startingTeamB[index]">
                                                        <span class="d-flex align-items-center" v-if="startingTeamB[index].player_name">
                                                            <a href="javascript:void(0)" data-toggle="modal" data-target="#selectPlayerModal" @click="selectPlayerForSlot(match.team_b, index)" 
                                                                class="btn btn-sm bg-light text-xs d-inline-flex h-auto align-items-center rounded-pill px-2 mr-1 shadow-sm"
                                                                v-if="[match.team_b?.owner_id,match.team_b?.captain_id].includes(player.id) && match.status !== 'completed'">
                                                                <span class="material-symbols-outlined text-sm">swap_vert</span>
                                                            </a>
                                                            <span>
                                                                <b v-if="match.team_b?.captain_id == startingTeamB[index].player_id">(C)</b>
                                                                {{ startingTeamB[index].player_name }}
                                                            </span>
                                                        </span>
                                                        <span v-else-if="[match.team_b?.owner_id,match.team_b?.captain_id].includes(player.id)">
                                                            <a href="javascript:void(0)" data-toggle="modal" data-target="#selectPlayerModal" @click="selectPlayerForSlot(match.team_b, index)" 
                                                                v-if="[match.team_b?.owner_id,match.team_b?.captain_id].includes(player.id)"
                                                                class="btn btn-sm bg-light text-xs d-inline-flex h-auto align-items-center rounded-pill px-2 shadow-sm">
                                                                Sélectionner joueur
                                                            </a>
                                                        </span>
                                                        <span v-else>Poste non attribué</span>
                                                        <span class="badge p-1 py-2 ml-2" v-if="startingTeamB[index].position" :class="startingPositions[startingTeamB[index].position]['class']" style="min-width: 34px;">
                                                            {{ startingPositions[startingTeamB[index].position]['abbr'] }}
                                                        </span>
                                                    </span>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                                <!-- <table class="table table-striped table-borderless text-sm mt-2">
                                    <thead class="thead-light">
                                        <tr>
                                            <th colspan="3" class="text-center">Remplaçants</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th colspan="3" class="text-center"></th>
                                        </tr>
                                    </tbody>
                                </table> -->
                            </div>
                            <div v-if="activeTab === 'h2h'" class="tab-pane fade show active">
                                <div class="row">
                                    <div class="col-md-6">
                                        <h6 class="text-sm font-weight-bold">Derniers matchs - {{ match.team_a?.name || 'Équipe A' }}</h6>
                                        <ul class="list-unstyled text-sm">
                                            <li v-if="recentMatchesTeamA.length === 0" class="text-muted">Aucun match.</li>
                                            <li v-for="m in recentMatchesTeamA" :key="m.id" class="py-2 border-bottom">
                                                <div class="d-flex justify-content-between">
                                                    <div>
                                                        <strong class="mr-1">{{ m.team_a?.name || 'N/A' }}</strong>
                                                        -
                                                        <strong class="ml-1">{{ m.team_b?.name || 'N/A' }}</strong>
                                                    </div>
                                                    <div>{{ (m.status === 'completed') ? (m.score_a + ' - ' + m.score_b) : '-' }}</div>
                                                </div>
                                                <div class="text-muted text-xs">{{ formatDateTime(m.booking?.start_time).date }} {{ formatDateTime(m.booking?.start_time).time }}</div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-6">
                                        <h6 class="text-sm font-weight-bold">Derniers matchs - {{ match.team_b?.name || 'Équipe B' }}</h6>
                                        <ul class="list-unstyled text-sm">
                                            <li v-if="recentMatchesTeamB.length === 0" class="text-muted">Aucun match.</li>
                                            <li v-for="m in recentMatchesTeamB" :key="m.id" class="py-2 border-bottom">
                                                <div class="d-flex justify-content-between">
                                                    <div>
                                                        <strong class="mr-1">{{ m.team_a?.name || 'N/A' }}</strong>
                                                        -
                                                        <strong class="ml-1">{{ m.team_b?.name || 'N/A' }}</strong>
                                                    </div>
                                                    <div>{{ (m.status === 'completed') ? (m.score_a + ' - ' + m.score_b) : '-' }}</div>
                                                </div>
                                                <div class="text-muted text-xs">{{ formatDateTime(m.booking?.start_time).date }} {{ formatDateTime(m.booking?.start_time).time }}</div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Page Content -->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->
    </div>

    <!-- Counter-Suggestion Modal (root level) -->
    <div class="modal fade" id="counterSuggestionModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Contre-propositions</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-light border text-sm">
                        Proposez une ou deux alternatives. Les créneaux initiaux seront libérés dès l'envoi.
                    </div>
                    <div v-for="(suggestion, index) in counterSuggestions" :key="suggestion.uid" class="border rounded-lg p-3 mb-3 bg-light">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <strong class="text-sm">Contre-proposition {{ index + 1 }}</strong>
                            <button v-if="counterSuggestions.length > 1" type="button" class="btn btn-sm btn-link text-danger p-0" @click="removeCounterSuggestion(index)">Retirer</button>
                        </div>
                        <div class="form-row">
                            <div class="col-md-4 mb-2">
                                <label class="text-xs mb-1">Terrain</label>
                                <div v-if="suggestion.facility_id" class="mb-2 p-2 border rounded bg-white">
                                    <div v-if="suggestion.establishment_name" class="text-sm font-weight-bold">{{ suggestion.establishment_name }}</div>
                                    <div v-if="suggestion.facility_name" class="text-xs text-muted">Terrain: {{ suggestion.facility_name }}</div>
                                </div>
                                <div v-else class="mb-2 p-2 border rounded bg-light text-xs text-muted">Aucun terrain choisi</div>
                                <button type="button" class="btn btn-sm btn-outline-secondary w-100" @click="openCounterFacilityPicker(index)">
                                    Choisir
                                </button>
                            </div>
                            <div class="col-md-4 mb-2">
                                <label class="text-xs mb-1">Date</label>
                                <input type="date" v-model="suggestion.date" class="form-control form-control-sm" @change="loadCounterSuggestionSlots(index)">
                            </div>
                            <div class="col-md-4 mb-2">
                                <label class="text-xs mb-1">Créneau</label>
                                <select class="form-control form-control-sm custom-select" v-model.number="suggestion.slot_index" :disabled="!suggestion.facility_id || !suggestion.date || suggestion.loading_slots" @change="onCounterSuggestionSlotChange(index)">
                                    <option :value="-1">Choisir...</option>
                                    <option v-for="(slot, slotIndex) in suggestion.slots" :key="slot.id" :value="slotIndex">
                                        {{ formatSlotLabel(slot) }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div v-if="suggestion.loading_slots" class="text-xs text-muted mt-1">Chargement des créneaux...</div>
                        <div v-else-if="suggestion.date && suggestion.facility_id && suggestion.slots.length === 0" class="text-xs text-muted mt-1">Aucun créneau confirmé disponible pour cette date.</div>
                        <div v-if="counterFacilityPicker.suggestionIndex === index" class="border rounded-lg p-3 mt-3 bg-white">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <h6 class="mb-0 text-sm">Choisir établissement et terrain</h6>
                                <button type="button" class="btn btn-sm btn-outline-secondary" @click="closeCounterFacilityPicker()">Fermer</button>
                            </div>
                            <div class="form-row">
                                <div class="col-md-6 mb-2">
                                    <label class="text-xs mb-1">Établissement</label>
                                    <select class="form-control custom-select" v-model="counterFacilityPicker.establishment_id" @change="onCounterFacilityPickerEstablishmentChange()">
                                        <option :value="null">Choisir...</option>
                                        <option v-for="establishment in counterEstablishments" :key="establishment.id" :value="establishment.id">{{ establishment.label }}</option>
                                    </select>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <label class="text-xs mb-1">Terrain</label>
                                    <select class="form-control custom-select" v-model="counterFacilityPicker.facility_id" :disabled="!counterFacilityPicker.establishment_id">
                                        <option :value="null">Choisir...</option>
                                        <option v-for="facility in counterFacilityPicker.facilities" :key="facility.id" :value="facility.id">{{ facility.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="text-right mt-2">
                                <button type="button" class="btn btn-sm btn-primary" @click="applyCounterFacilityPicker()">Valider</button>
                            </div>
                        </div>
                    </div>
                    <button v-if="counterSuggestions.length < 2" type="button" class="btn btn-sm btn-outline-secondary rounded-pill" @click="addCounterSuggestion()">
                        Ajouter une proposition
                    </button>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light" data-dismiss="modal">Annuler</button>
                    <button type="button" class="btn btn-primary" @click="submitCounterSuggestions()">
                        Envoyer les contre-propositions
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="selectPlayerModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header align-items-center">
                    <h5 v-if="currentModalView == 'select-player'" class="modal-title">Sélectionner un joueur</h5>
                    <h5 v-if="currentModalView == 'add-guest-player'" class="modal-title">Ajouter joueur hors 6v6</h5>
                    <button v-if="currentModalView == 'select-player'" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span class="material-symbols-outlined">close</span>
                    </button>
                    <button v-if="currentModalView !== 'select-player'" @click="currentModalView = 'select-player'" type="button" class="btn btn-sm btn-outline-secondary">Retour</button>
                </div>
                <div class="modal-body mb-4" style="min-height: 40vh;">
                    <div id="searchData" v-if="currentModalView == 'select-player'">
                        <form class="form-inline">
                            <input type="text" v-model="search.criteria.eligiblePlayers.player_name" class="form-control shadow-sm rounded-pill bg-light mr-2 w-auto" placeholder="Nom Joueur" style="min-height: 40px;max-width: 50%;">
                            <a href="javascript:void(0)" class="btn bg-light rounded-pill d-flex align-items-center shadow-sm text-sm ml-1 py-2 px-3" 
                                @click="currentModalView = 'add-guest-player'">
                                <span class="material-symbols-outlined text-lg mr-1">person_add</span>
                                Joueur Hors 6v6
                            </a>
                        </form>
                        <div v-if="filteredPlayersData.length > 0">
                            <div class="table-responsive text-sm pt-2">
                                <table class="table table-hover table-center mb-0">
                                    <thead class="bg-light">
                                        <tr>
                                            <th>Nom Joueur</th>
                                            <th>Role</th>
                                            <th>Poste</th>
                                            <th>Poste(s) Préféré(s)</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="player in paginatedPlayersData">
                                            <td style="min-width: 150px;">{{ player.player_name }}</td>
                                            <td>{{ membershipRoles[player.role] }}</td>
                                            <td>
                                                <span class="badge p-1 py-2 mr-2" v-if="player.position" :class="startingPositions[player.position]['class']" style="min-width: 25px;">
                                                    {{ startingPositions[player.position]['abbr'] }}
                                                </span>
                                            </td>
                                            <td>
                                                <template v-if="player.player_id">
                                                    <span v-for="position in playersPreferredPositions[player.player_id].split(',')" class="badge p-2 ml-1" :class="startingPositions[position]['class']">
                                                        {{ startingPositions[position]['abbr'] }}
                                                    </span>
                                                </template>
                                            </td>
                                            <td>
                                                <span class="btn btn-sm btn-outline-info rounded-pill pt-0"
                                                    @click="choosePlayer(player)" data-dismiss="modal">
                                                    <span class="text-xs">Sélectionner</span>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- PAGINATION -->
                            <nav class="mt-3">
                                <ul class="pagination justify-content-center">
                                    <li class="page-item" :class="{ disabled: currentPlayersPage === 1 }">
                                        <button class="page-link text-dark" @click="goToPage(currentPlayersPage - 1, 'players')">
                                            <span class="material-symbols-outlined text-sm">arrow_back</span>
                                        </button>
                                    </li>
                                    <li class="page-item" v-for="page in totalPlayersPages" :key="page" :class="{ active: currentPlayersPage === page }">
                                        <button class="page-link" @click="goToPage(page, 'players')" :class="{ 'text-white': currentPlayersPage === page, 'text-muted': currentPlayersPage !== page }">
                                            {{ page }}
                                        </button>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPlayersPage === totalPlayersPages }">
                                        <button class="page-link text-dark" @click="goToPage(currentPlayersPage + 1, 'players')">
                                            <span class="material-symbols-outlined text-sm">arrow_forward</span>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div v-else class="mt-5 text-sm text-center">
                            Aucune correspondance précise
                        </div>
                    </div>
                    <div id="addGuestPlayer" v-if="currentModalView == 'add-guest-player'">
                        <input type="text" v-model="guest" class="form-control" placeholder="Nom Joueur" style="min-height: 40px;max-width: 50%;">
                    </div>
                </div>
                <div class="modal-footer" v-if="currentModalView == 'add-guest-player'">
                    <button type="button" class="btn btn-sm btn-primary" @click="addGuest(guest)">Ajouter</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.nav-tabs.nav-justified > li > a {
    width: 100% !important;
}

.action-marker {
    width: 22px;
    height: 22px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 22px;
}

.action-marker-icon {
    font-size: 14px !important;
    line-height: 1;
}

.summary-event {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.summary-event-left {
    flex-direction: row;
    text-align: left;
}

.summary-event-right {
    flex-direction: row-reverse;
    text-align: right;
}

.summary-event-minute {
    min-width: 42px;
    flex: 0 0 42px;
}

.summary-event-marker {
    flex: 0 0 22px;
}

.summary-event-copy {
    flex: 1 1 auto;
    min-width: 0;
}

.tone-goal {
    background: rgba(25, 135, 84, 0.12);
    color: #198754;
}

.tone-yellow {
    background: rgba(255, 193, 7, 0.16);
    color: #b58100;
}

.tone-red {
    background: rgba(220, 53, 69, 0.14);
    color: #dc3545;
}

.tone-neutral {
    background: rgba(108, 117, 125, 0.12);
    color: #6c757d;
}

.live-minute-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem 0.7rem;
    border-radius: 999px;
    color: #fff;
    font-weight: 700;
    font-size: 0.75rem;
    letter-spacing: 0.04em;
    background: #A61616;
    animation: livePulse 1.4s ease-in-out infinite;
}

@keyframes livePulse {
    0% {
        background: #A61616;
        box-shadow: 0 0 0 0 rgba(166, 22, 22, 0.35);
    }
    50% {
        background: #E63232;
        box-shadow: 0 0 12px 2px rgba(230, 50, 50, 0.45);
    }
    100% {
        background: #A61616;
        box-shadow: 0 0 0 0 rgba(166, 22, 22, 0.35);
    }
}

.font-size-1 {
    font-size: 1rem !important;
}

.align-middle-important {
    vertical-align: middle !important;
}

.counter-facility {
    flex: 1 1 60%;
    min-width: 200px;
}
.counter-establishment {
    flex: 1 1 60%;
    min-width: 200px;
}
.counter-date {
    flex: 0 0 140px;
}
.counter-slot {
    flex: 1 1 220px;
    min-width: 220px;
}

.counter-row {
    display: flex;
    align-items: flex-end;
    gap: 0.5rem;
    flex-wrap: wrap;
}
@media (min-width: 768px) {
    .counter-row {
        flex-wrap: nowrap;
    }
}
</style>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import CustomerSidebar from "@/components/Customers/Partials/Sidebar";
import defaultTeamLogoPath from '@/assets/img/default-team-logo.png'

export default {
    components: {
        "customer-sidebar": CustomerSidebar,
        vSelect
    },
    props: ['id'],
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        liveBooking() {
            return this.getReferenceBooking(this.match)
        },
        liveMinute() {
            const booking = this.liveBooking
            if (!booking?.start_time || !booking?.end_time) return null

            const now = new Date(this.now)
            const start = new Date(booking.start_time)
            const end = new Date(booking.end_time)

            if (Number.isNaN(now.getTime()) || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return null
            if (now < start || now > end) return null

            const minute = Math.floor((now - start) / 60000) + 1
            return minute > 0 ? minute : 1
        },
        showLiveMinute() {
            return this.liveMinute !== null
        },
        startingTeamA() {
            return this.getStartingLineup(
                this.match.team_a,
                this.match.team_a_formation
            );
        },
        startingTeamB() {
            return this.getStartingLineup(
                this.match.team_b,
                this.match.team_b_formation
            );
        },
        canEditTeamA() {
            return this.canEditTeam(this.match.team_a);
        },
        canEditTeamB() {
            return this.canEditTeam(this.match.team_b);
        },
        totalPages() {
            return Math.ceil(this.teams.length / this.perPage);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.teams.slice(start, start + this.perPage);
        },
        filteredPlayersData() {
            let filteredData = this.eligiblePlayers
            const keys = Object.keys(this.search.criteria.eligiblePlayers)
            keys.forEach(key => {
                if (!this.isEmpty(this.search.criteria.eligiblePlayers[key])) {
                    filteredData = filteredData.filter(player => {
                        return player[key].toLowerCase().includes(this.search.criteria.eligiblePlayers[key].toLowerCase())
                    });
                }
            })
            return filteredData
        },
        totalPlayersPages() {
            return Math.ceil(this.filteredPlayersData.length / this.playersPerPage);
        },
        paginatedPlayersData() {
            const start = (this.currentPlayersPage - 1) * this.playersPerPage;
            return this.filteredPlayersData.slice(start, start + this.playersPerPage);
        },
        showResumeTab() {
            return this.hasMatchStarted(this.match)
        },
        orderedMatchActions() {
            return [...(this.matchActions || [])].sort((a, b) => (a.minute || 0) - (b.minute || 0))
        },
        summaryTeamAActions() {
            return this.orderedMatchActions.filter(action => action.team_id === this.match.team_a_id)
        },
        summaryTeamBActions() {
            return this.orderedMatchActions.filter(action => action.team_id === this.match.team_b_id)
        },
        matchCapacitySlots() {
            return this.getMatchCapacity(this.match) || 0;
        },
    },
    data() {
        return {
            activeTab: 'general',
            defaultTeamLogoPath: defaultTeamLogoPath,
            match: {
                team_a: null,
                team_b: null,
                team_a_formation: null,
                team_b_formation: null,
                lineups: [],
                suggestions: []
            },
            matchActions: [],
            recentMatchesTeamA: [],
            recentMatchesTeamB: [],
            player: {},
            formationPositions: ['goalkeeper','defender', 'midfielder', 'forward'],
            defaultLineup: {
                id: null,
                match_id: this.id,
                team_id: null,
                player_id: null,
                player_name: '',
                is_guest: false,
                position: null,
                role: 'substitute',
                status: 'confirmed'
            },
            search: {
                criteria: {
                    eligiblePlayers: {
                        player_name: null,
                    }
                },
            },
            currentPlayersPage: 1,     // selected page
            playersPerPage: 8,         // items per page
            eligiblePlayers: [],
            playersPreferredPositions: {},
            selectedSlotIndex: null,
            selectedSlot: {},
            selectedTeam: null,
            currentModalView: 'select-player',
            guest: null,
            teams: [],
            myTeams: [],
            opponentTeams: [],
            counterFacilities: [],
            counterSuggestions: [],
            possibleFormations: [], // for 6v6
            counterFacilityPicker: {
                suggestionIndex: null,
                establishment_id: null,
                facility_id: null,
                facilities: [],
            },
            membershipRoles: {
                'captain': 'Capitaine',
                'starting': 'Titulaire',
                'substitute': 'Remplaçant'
            },
            statuses: {
                'challenged': {'label': 'défi en cours', 'class': 'bg-primary'},
                'scheduled': {'label': 'à venir', 'class': 'bg-primary-light'},
                'completed': {'label': 'terminé', 'class': 'bg-success-light'},
                'cancelled': {'label': 'annulé', 'class': 'bg-danger text-white'},
                'unfinished': {'label': 'inachevé', 'class': 'bg-danger-light'},
            },
            challengeStatuses: {
                'pending': {'label': 'en attente', 'class': 'bg-warning-light'},
                'countered': {'label': 'contre-proposé', 'class': 'bg-info-light'},
                'accepted': {'label': 'accepté', 'class': 'bg-success-light'},
                'declined': {'label': 'rejeté', 'class': 'bg-danger-light'},
                'cancelled': {'label': 'annulé', 'class': 'bg-danger-light'},
            },
            proposalStatuses: {
                'pending': {'label': 'En cours', 'class': 'bg-warning-light'},
                'declined': {'label': 'Rejeté', 'class': 'bg-danger-light'},
                'accepted': {'label': 'Accepté', 'class': 'bg-success-light'},
            },
            startingPositions: {
                'goalkeeper': {'abbr': 'G', 'class': 'bg-warning-light'},
                'defender': {'abbr': 'DF', 'class': 'bg-primary-light'},
                'midfielder': {'abbr': 'ML', 'class': 'bg-success-light'},
                'forward': {'abbr': 'AT', 'class': 'bg-danger-light'}
            },
            currentPage: 1,     // selected page
            perPage: 5,         // items per page
            now: Date.now(),
            liveTimer: null,
            selectedStarting: {},
            selectedIndex: null,
            counterEstablishments: [],
        }
    },
    mounted() {
        this.getMyPlayerProfile()
        this.getMatch()
        this.getMyTeams()
        this.getOpponentTeams()
        this.startLiveClock()
    },
    beforeUnmount() {
        if (this.liveTimer) {
            clearInterval(this.liveTimer)
            this.liveTimer = null
        }
    },
    watch: {
        'match.team_a_formation'(val) {
            if (this.canEditTeam(this.match.team_a)) {
                this.balanceStarters(this.match.team_a, val);
            }
        },
        'match.team_b_formation'(val) {
            if (this.canEditTeam(this.match.team_b)) {
                this.balanceStarters(this.match.team_b, val);
            }
        },
        'search.criteria.eligiblePlayers': {
            deep: true,
            handler() {
                this.currentPlayersPage = 1;
            }
        }
    },
    methods: {
        actionTypeLabel(actionType) {
            if (actionType === 'goal') return 'But'
            if (actionType === 'yellow_card') return 'Carton jaune'
            if (actionType === 'red_card') return 'Carton rouge'
            return actionType || 'Action'
        },
        actionTypeIcon(actionType) {
            if (actionType === 'goal') return 'sports_soccer'
            return 'crop_square'
        },
        actionTypeTone(actionType) {
            if (actionType === 'goal') return 'tone-goal'
            if (actionType === 'yellow_card') return 'tone-yellow'
            if (actionType === 'red_card') return 'tone-red'
            return 'tone-neutral'
        },
        startLiveClock() {
            this.now = Date.now()
            if (this.liveTimer) {
                clearInterval(this.liveTimer)
            }
            this.liveTimer = setInterval(() => {
                this.now = Date.now()
            }, 15000)
        },
        getMyPlayerProfile() {
            api.get('/private/players/me').then(res => {
                this.player = res.data;
            });
        },
        getMyTeams() {
            api.get('/private/players/my/teams/current')
                .then(response => {
                    const result = response.data
                    this.myTeams = result.filter(team => this.player.id === team?.owner_id || this.player.id === team?.captain_id)
                })
        },
        getOpponentTeams() {
            api.get('/private/teams/search')
                .then(response => {
                    const result = response.data
                    this.opponentTeams = result.filter(team => {
                        const membership = team.memberships.filter(m => m.player_id === this.player.id && ['accepted', 'pending'].includes(m.status))
                        return membership.length === 0
                    })
                })
        },
        getMatch() {
            api.get(`/private/matches/${this.id}`).then(res => {
                let match = res.data;
                const facility_capacity = this.getMatchCapacity(match)
                if (facility_capacity) {
                    this.possibleFormations = this.generateFormations(facility_capacity)
                } else {
                    this.possibleFormations = []
                }

                if (facility_capacity && this.possibleFormations.length) {
                    match.team_a_formation ||= (parseInt(match.team_a?.format.split('v')[0]) === facility_capacity) ? match.team_a?.formation : this.possibleFormations[0];
                    match.team_b_formation ||= (parseInt(match.team_b?.format.split('v')[0]) === facility_capacity) ? match.team_b?.formation : this.possibleFormations[0];
                    match.team_b_formation ||= (parseInt(match.team_b?.format.split('v')[0]) === facility_capacity) ? match.team_b?.formation : this.possibleFormations[0];
                } else {
                    match.team_a_formation ||= match.team_a?.formation || null;
                    match.team_b_formation ||= match.team_b?.formation || null;
                }
                let team_a_lineups = match.lineups.filter(l => l.team_id === match.team_a_id)
                let team_b_lineups = match.lineups.filter(l => l.team_id === match.team_b_id)
                let team_a_guests = team_a_lineups.filter(l => l.is_guest)
                let team_b_guests = team_b_lineups.filter(l => l.is_guest)

                match.team_a.memberships
                    .filter(m => m.status === 'accepted')
                    .forEach(m => {
                        this.playersPreferredPositions[m.player_id] = m.player.position
                    })
                match.team_b.memberships
                    .filter(m => m.status === 'accepted')
                    .forEach(m => {
                        this.playersPreferredPositions[m.player_id] = m.player.position
                    })
                // INIT FULL LINEUP ONLY ONCE
                if (!match.lineups || !match.lineups.length) {
                    match.lineups = [
                        ...this.initTeamLineup(match.team_a, match.team_a_formation, team_a_guests),
                        ...this.initTeamLineup(match.team_b, match.team_b_formation, team_b_guests)
                    ];
                }
                if (this.lineupToInit(team_a_lineups)) {
                    var team_lineups = this.initTeamLineup(match.team_a, match.team_a_formation, team_a_guests)
                    team_a_lineups = team_lineups.length ? team_lineups : team_a_lineups
                }
                if (this.lineupToInit(team_b_lineups)) {
                    var team_lineups = this.initTeamLineup(match.team_b, match.team_b_formation, team_b_guests)
                    team_b_lineups = team_lineups.length ? team_lineups : team_b_lineups
                }
                match.lineups = [ ...team_a_lineups, ...team_b_lineups]
                if (match.status === 'scheduled' && !this.notStartedYet(match)) {
                    match.status = 'completed'
                }
                this.match = match
                this.loadHeadToHead()
                this.loadMatchActions()
                if (this.showResumeTab) {
                    this.activeTab = 'summary'
                }
            });
        },
        loadMatchActions() {
            if (!this.match?.id || !this.showResumeTab) {
                this.matchActions = []
                return
            }
            api.get(`/private/matches/${this.id}/actions`).then(res => {
                this.matchActions = res.data || []
            }).catch(() => {
                this.matchActions = []
            })
        },
        async loadHeadToHead() {
            if (!this.match?.id) return
            try {
                const res = await api.get('/private/matches')
                const all = res.data || []
                const teamAId = this.match.team_a_id
                const teamBId = this.match.team_b_id
                const forTeam = id => all
                    .filter(m => m.team_a_id === id || m.team_b_id === id)
                    .sort((a, b) => {
                        const ta = (a.booking && a.booking.start_time) ? new Date(a.booking.start_time) : new Date(0)
                        const tb = (b.booking && b.booking.start_time) ? new Date(b.booking.start_time) : new Date(0)
                        return tb - ta
                    })
                    .slice(0, 5)
                this.recentMatchesTeamA = forTeam(teamAId)
                this.recentMatchesTeamB = forTeam(teamBId)
            } catch (e) {
                this.recentMatchesTeamA = []
                this.recentMatchesTeamB = []
            }
        },
        submitScore() {
            if (!this.canEditTeamA) return;
            const payload = {
                score_a: this.match.score_a,
                score_b: this.match.score_b
            }
            api.post(`/private/matches/${this.id}/submit_score`, payload)
                .then(() => {
                    this.getMatch()
                })
                .catch(err => {
                    alert(err.response?.data?.detail || 'Erreur lors de la soumission du score')
                })
        },
        confirmScore() {
            if (!this.canEditTeamB) return;
            const payload = { confirm_score: true }
            api.post(`/private/matches/${this.id}/confirm_score`, payload)
                .then(() => {
                    this.getMatch()
                })
                .catch(err => {
                    alert(err.response?.data?.detail || 'Erreur lors de la confirmation du score')
                })
        },
        lineupToInit(lineup) {
            const lineupGuests = lineup.filter(l => l.is_guest)
            const lineupSubstitutes = lineup.filter(l => l.role === 'substitute')
            return lineupSubstitutes.length === lineup.length || lineupGuests.length === lineup.length
        },
        getTeam(side, team_id) {
            api.get('/private/teams/'+team_id)
                .then(response => {
                    const result = response.data
                    const team_key = side === 'home' ? 'team_a' : 'team_b'
                    this.match[team_key] = result
                    this.match.lineups = [
                        ...this.initTeamLineup(this.match.team_a, this.match.team_a_formation),
                        ...this.initTeamLineup(this.match.team_b, this.match.team_b_formation)
                    ];
                })
        },
        save() {
            const payload = {
                team_a_id: this.myTeam?.id,
                team_b_id: this.opponentTeam?.id,
                team_a_formation: this.match.team_a_formation,
                team_b_formation: this.match.team_b_formation,
                score_a: this.match.score_a,
                score_b: this.match.score_b,
                lineup: ([this.match.team_b?.owner_id, this.match.team_b?.captain_id].includes(this.player.id)) ? this.lineupTeamB : this.lineupTeamA
            }
            api.post(`/private/matches/${this.id}`, payload)
                .then(response => {
                    this.getMatch()
                })
        },
        cancel() {
            api.post(`/private/matches/${this.id}/cancel`)
                .then(response => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: 'Le match a été annulé avec succès.',
                    })
                    this.getMatch()
                })
                .catch(error => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'error',
                        icon_color: 'text-danger',
                        title: 'Erreur',
                        detail: error.response?.data?.detail || 'Une erreur est survenue! Veuillez réessayer plus tard.',
                    })
                })
        },
        respondToChallenge(status, suggestionId = null) {
            const payload = { status: status }
            if (suggestionId) {
                payload.suggestion_id = suggestionId
            } else {
                payload.bookingExists = true
            }

            api.post(`/private/matches/${this.id}/challenge`, payload)
                .then(response => {
                    this.getMatch()
                })
                .catch(error => {
                    alert(error.response?.data?.detail || 'Une erreur est survenue! Veuillez réessayer plus tard.')
                })
        },
        newCounterSuggestion() {
            return {
                uid: `${Date.now()}-${Math.random().toString(36).substring(2,11)}-${Math.random().toString(36).substring(2,11)}`,
                establishment_id: null,
                facility_id: null,
                establishment_name: '',
                facility_name: '',
                date: null,
                slot_index: -1,
                start_time: null,
                end_time: null,
                slots: [],
                loading_slots: false,
            }
        },
        formatSlotRange(slot) {
            if (!slot) return ''
            return `${this.formatTime(slot.start_time)} -> ${this.formatTime(slot.end_time)}`
        },
        formatSlotLabel(slot) {
            if (!slot) return ''
            return this.formatSlotRange(slot)
        },
        loadCounterSuggestionSlots(index) {
            const suggestion = this.counterSuggestions[index]
            if (!suggestion) return Promise.resolve([])

            if (!suggestion.establishment_id || !suggestion.facility_id || !suggestion.date) {
                suggestion.slots = []
                suggestion.slot_index = -1
                suggestion.start_time = null
                suggestion.end_time = null
                return Promise.resolve([])
            }

            const selectedFacility = this.counterFacilities.find(f => f.id === suggestion.facility_id)
            if (selectedFacility) {
                suggestion.establishment_name = selectedFacility.establishment_name || ''
                suggestion.facility_name = selectedFacility.facility_name || ''
            }

            suggestion.loading_slots = true
            return api.get(`/search/slots/${suggestion.date}/facility/${suggestion.facility_id}`)
                .then(response => {
                    const result = response.data || []
                    const now = moment().format('YYYY-MM-DDTHH:mm:ss.000000')
                    const slots = result
                        .filter(slot => slot.available && slot.status === 'available' && slot.start_time > now)
                        .map(slot => ({
                            ...slot,
                            establishment_name: slot.facility?.establishment?.business_name || '',
                            facility_name: slot.facility?.name || '',
                        }))

                    suggestion.slots = slots
                    if (suggestion.initial_slot_id) {
                        const foundIndex = slots.findIndex(s => s.id === suggestion.initial_slot_id)
                        if (foundIndex >= 0) {
                            suggestion.slot_index = foundIndex
                            suggestion.start_time = slots[foundIndex].start_time
                            suggestion.end_time = slots[foundIndex].end_time
                        } else {
                            suggestion.slot_index = -1
                            suggestion.start_time = null
                            suggestion.end_time = null
                        }
                        suggestion.initial_slot_id = null
                    } else if (suggestion.slot_index < 0 || suggestion.slot_index >= slots.length) {
                        suggestion.slot_index = -1
                        suggestion.start_time = null
                        suggestion.end_time = null
                    }
                    return slots
                })
                .catch(() => {
                    suggestion.slots = []
                    suggestion.slot_index = -1
                    suggestion.start_time = null
                    suggestion.end_time = null
                    return []
                })
                .finally(() => {
                    suggestion.loading_slots = false
                })
        },
        onCounterSuggestionSlotChange(index) {
            const suggestion = this.counterSuggestions[index]
            if (!suggestion) return

            const selectedSlot = (Number.isInteger(suggestion.slot_index) && suggestion.slot_index >= 0) ? suggestion.slots[suggestion.slot_index] : null
            suggestion.start_time = selectedSlot?.start_time || null
            suggestion.end_time = selectedSlot?.end_time || null
        },
        loadCounterFacilitiesByEstablishment(establishmentId) {
            if (!establishmentId) {
                this.counterFacilityPicker.facilities = []
                return Promise.resolve([])
            }

            const facilities = this.counterFacilities.filter(facility => facility.establishment_id === establishmentId)
            this.counterFacilityPicker.facilities = facilities
            return Promise.resolve(facilities)
        },
        openCounterFacilityPicker(index) {
            const suggestion = this.counterSuggestions[index]
            this.counterFacilityPicker.suggestionIndex = index
            this.counterFacilityPicker.establishment_id = suggestion?.establishment_id || null
            this.counterFacilityPicker.facility_id = suggestion?.facility_id || null
            this.counterFacilityPicker.facilities = []
            this.loadCounterFacilitiesByEstablishment(this.counterFacilityPicker.establishment_id)
        },
        closeCounterFacilityPicker() {
            this.counterFacilityPicker.suggestionIndex = null
            this.counterFacilityPicker.establishment_id = null
            this.counterFacilityPicker.facility_id = null
            this.counterFacilityPicker.facilities = []
        },
        onCounterFacilityPickerEstablishmentChange() {
            this.counterFacilityPicker.facility_id = null
            this.loadCounterFacilitiesByEstablishment(this.counterFacilityPicker.establishment_id)
        },
        applyCounterFacilityPicker() {
            const index = this.counterFacilityPicker.suggestionIndex
            if (index === null || index === undefined) return

            const selectedFacility = this.counterFacilityPicker.facilities.find(facility => facility.id === this.counterFacilityPicker.facility_id)
            this.counterSuggestions[index].establishment_id = this.counterFacilityPicker.establishment_id
            this.counterSuggestions[index].facility_id = this.counterFacilityPicker.facility_id
            this.counterSuggestions[index].facility_name = selectedFacility?.name || null
            this.counterSuggestions[index].establishment_name = selectedFacility?.establishment_name || null
            this.counterSuggestions[index].slot_index = -1
            this.counterSuggestions[index].start_time = null
            this.counterSuggestions[index].end_time = null
            this.counterSuggestions[index].slots = []
            this.closeCounterFacilityPicker()
            this.loadCounterSuggestionSlots(index)
        },
        openCounterSuggestionForm() {
            this.counterSuggestions = [this.newCounterSuggestion()]
            this.counterFacilities = []
            this.counterEstablishments = []
            this.closeCounterFacilityPicker()

            api.get('/private/facilities')
                .then(response => {
                    const all = response.data || []
                    this.counterFacilities = all.map(f => ({
                        id: f.id,
                        establishment_id: f.establishment?.id || null,
                        name: f.name,
                        establishment_name: f.establishment?.business_name || '',
                        facility_name: f.name || '',
                        label: `${f.establishment?.business_name || ''}${f.establishment?.business_name && f.name ? ' - Terrain ' : ''}${f.name || ''}`,
                    }))
                    this.counterEstablishments = all.reduce((items, facility) => {
                        const establishment = facility.establishment
                        if (establishment && !items.some(item => item.id === establishment.id)) {
                            items.push({
                                id: establishment.id,
                                label: establishment.business_name || '',
                            })
                        }
                        return items
                    }, [])

                    this.$nextTick(() => {
                        this.counterSuggestions.forEach((_, index) => this.loadCounterSuggestionSlots(index))
                    })
                })
                .catch(() => {
                    this.counterSuggestions = [this.newCounterSuggestion()]
                })
        },
        addCounterSuggestion() {
            if (this.counterSuggestions.length < 2) {
                this.counterSuggestions.push(this.newCounterSuggestion())
            }
        },
        removeCounterSuggestion(index) {
            if (this.counterSuggestions.length > 1) {
                this.counterSuggestions = this.counterSuggestions.filter((_, i) => i !== index)
            }
        },
        submitCounterSuggestions() {
            const hasPartialRow = this.counterSuggestions.some(suggestion => {
                const hasAny = suggestion.establishment_id || suggestion.facility_id || suggestion.date || (Number.isInteger(suggestion.slot_index) && suggestion.slot_index >= 0)
                const hasAll = suggestion.establishment_id && suggestion.facility_id && suggestion.date && (Number.isInteger(suggestion.slot_index) && suggestion.slot_index >= 0)
                return hasAny && !hasAll
            })

            if (hasPartialRow) {
                this.$store.dispatch('modal/triggerModal', {
                    icon: 'error',
                    icon_color: 'text-danger',
                    title: 'Erreur',
                    detail: 'Chaque contre-proposition doit contenir établissement, terrain, date et créneau.',
                })
                return
            }

            const suggestions = this.counterSuggestions
                .filter(suggestion => suggestion.establishment_id && suggestion.facility_id && suggestion.date && suggestion.start_time && suggestion.end_time)
                .map(suggestion => ({
                    establishment_id: suggestion.establishment_id,
                    facility_id: suggestion.facility_id,
                    date: suggestion.date,
                    start_time: suggestion.start_time,
                    end_time: suggestion.end_time,
                }))

            if (suggestions.length === 0) {
                this.$store.dispatch('modal/triggerModal', {
                    icon: 'error',
                    icon_color: 'text-danger',
                    title: 'Erreur',
                    detail: 'Ajoutez au moins une contre-proposition valide.',
                })
                return
            }

            api.post(`/private/matches/${this.id}/challenge`, { status: 'counter_suggested', suggestions })
                .then(() => {
                    $('#counterSuggestionModal').modal('hide')
                    this.getMatch()
                })
                .catch(error => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'error',
                        icon_color: 'text-danger',
                        title: 'Erreur',
                        detail: error.response?.data?.detail || 'Une erreur est survenue! Veuillez réessayer plus tard.',
                    })
                })
        },
        addGuest(player_name) {
            api.post(`/private/matches/${this.id}/guest`, {
                ...this.defaultLineup,
                is_guest: true,
                player_name: player_name,
                team_id: this.selectedTeam.id
            })
                .then(response => {
                    const guest = response.data
                    this.guest = null
                    // this.getTeam(this.selectedSide, this.selectedTeam.id)
                    this.match.lineups.push(guest)
                    this.selectPlayerForSlot(this.selectedTeam, this.selectedSlotIndex)
                    this.currentModalView = 'select-player'
                })
        },
        /* ===================================================
        * PERMISSIONS
        * =================================================== */
        canEditTeam(team) {
            if (!team || !this.player?.id) return false;
            return team?.owner_id === this.player.id || team?.captain_id === this.player.id;
        },
        /* ===================================================
        * INITIALIZATION
        * =================================================== */
        initTeamLineup(team, formation, team_guests = []) {
            if (!team || !formation) return [];
            const slots = this.buildFormationMap(formation);
            const orderedPositions = this.formationPositions;
            // accepted members only
            let members = team.memberships
                .filter(m => m.status === 'accepted')
                .map(m => ({
                    id: null,
                    match_id: this.id,
                    team_id: team.id,
                    player_id: m.player_id,
                    player_name: m.player.name,
                    is_guest: false,
                    role: m.role === 'starting' ? 'starting' : 'substitute',
                    position: m.lineup_position || null,
                    status: 'confirmed'
                }));

            members = [...members, ...team_guests]

            const starters = [];
            const used = new Set();

            /* ----------------------------------------
            * 1. Place membership starters first
            * ---------------------------------------- */
            orderedPositions.forEach(position => {
                const max = slots[position] || 0;
                if (!max) return;
                const candidates = members.filter(
                    m => m.role === 'starting' && (m.position === position || (m.player_id && this.playersPreferredPositions[m.player_id].includes(position))) && !used.has(m.player_id)
                );
                console.log(team.name, position, candidates)
                candidates.slice(0, max).forEach(p => {
                    p.position = position
                    starters.push(p);
                    used.add(p.player_id);
                });
            });

            /* ----------------------------------------
            * 2. Fill remaining slots with starters (wrong position)
            * ---------------------------------------- */
            orderedPositions.forEach(position => {
                const filled = starters.filter(s => s.position === position).length;
                const remaining = (slots[position] || 0) - filled;
                if (remaining <= 0) return;
                const candidates = members.filter(m => m.role === 'starting' && !used.has(m.player_id));
                candidates.slice(0, remaining).forEach(p => {
                    p.position = position;
                    starters.push(p);
                    used.add(p.player_id);
                });
            });

            /* ----------------------------------------
            * 3. Fill with substitutes if still needed
            * ---------------------------------------- */
            orderedPositions.forEach(position => {
                const filled = starters.filter(s => s.position === position).length;
                const remaining = (slots[position] || 0) - filled;
                if (remaining <= 0) return;
                const candidates = members.filter(m => m.role === 'substitute' && !used.has(m.player_id));

                candidates.slice(0, remaining).forEach(p => {
                    p.role = 'starting';
                    p.position = position;
                    starters.push(p);
                    used.add(p.player_id);
                });
            });

            /* ----------------------------------------
            * 4. Demote overflow starters
            * ---------------------------------------- */
            members.forEach(m => {
                if (m.role === 'starting' && !used.has(m.player_id)) {
                    m.role = 'substitute';
                    m.position = null;
                }
            });

            return members;
        },
        /* ===================================================
        * FORMATION & DERIVED LINEUPS
        * =================================================== */
        buildFormationMap(formation) {
            const [d, m, f] = formation.split('-').map(Number);
            return {
                goalkeeper: 1,
                defender: d,
                midfielder: m,
                forward: f
            };
        },
        getStartingLineup(team, formation) {
            if (!team || !formation) return [];
            const formationMap = this.buildFormationMap(formation);
            const starters = this.match.lineups.filter(
                l => l.team_id === team.id && l.role === 'starting'
            );
            const result = [];
            this.formationPositions.forEach(pos => {
                const needed = formationMap[pos];
                const players = starters.filter(p => p.position === pos);

                for (let i = 0; i < needed; i++) {
                    result.push(
                        players[i] || {
                            ...this.defaultLineup,
                            match_id: this.id,
                            team_id: team.id,
                            position: pos
                        }
                    );
                }
            });
            return result;
        },
        balanceStarters(team, formation) {
            if (!team || !formation) return;
            const formationMap = this.buildFormationMap(formation);
            let starters = this.match.lineups.filter(
                l => l.team_id === team.id && l.role === 'starting'
            );
            let player_starters = starters.filter(
                l => !l.is_guest
            )
            if (!starters.length || !player_starters.length) {
                const team_guests = this.match.lineups.filter(
                    l => l.team_id === team.id && l.is_guest
                );
                starters = this.initTeamLineup(team, formation, [...team_guests])
                console.log(starters)
                const new_lineups = starters.filter(s => !s.id)
                new_lineups.forEach(nl => {
                    this.match.lineups.push(nl)
                })
            }
            const grouped = this.formationPositions.reduce((acc, pos) => {
                acc[pos] = starters.filter(p => p.position === pos);
                return acc;
            }, {});
            const keep = [];
            this.formationPositions.forEach(pos => {
                grouped[pos]?.slice(0, formationMap[pos]).forEach(p => keep.push(p));
            });
            this.match.lineups = this.match.lineups.map(l => {
                if (l.team_id !== team.id) return l;
                if (
                    l.role === 'starting' &&
                    !keep.some(k => this.isSamePlayer(k, l))
                ) {
                    return { ...l, role: 'substitute' };
                }
                return l;
            });
        },
        getEligiblePlayersForSlot(team, slotPlayer = null) {
            if (!team) return [];

            // all lineups for this team
            const lineups = this.match.lineups.filter(l => l.team_id === team.id);

            // combine and exclude current slot player
            return lineups.filter(p => {
                if (!slotPlayer) return true;
                return !this.isSamePlayer(p, slotPlayer);
            });
        },
        selectPlayerForSlot(team, slotIndex) {
            const startingTeam = (team.id === this.match.team_a?.id) ? this.startingTeamA : this.startingTeamB;
            const slotPlayer = startingTeam[slotIndex]; // or B
            this.eligiblePlayers = this.getEligiblePlayersForSlot(team, slotPlayer);
            this.selectedSlotIndex = slotIndex;
            this.selectedSlot = startingTeam[slotIndex];
            this.selectedTeam = team;

            // open modal or dropdown
            this.currentModalView = 'select-player';
        },
        /* ===================================================
        * LINEUP MUTATION (ONLY PLACE)
        * =================================================== */
        swapIntoStartingSlot({ team, position, slotIndex, incomingPlayer }) {
            // 🔒 Permission check
            if (!this.canEditTeam(team)) return;
            const formation = team.id === this.match.team_a.id ? this.match.team_a_formation : this.match.team_b_formation;
            const starters = this.getStartingLineup(team, formation);
            const targetStarter = starters[slotIndex]; // may be empty slot
            this.match.lineups = this.match.lineups.map(l => {
                const isIncoming = incomingPlayer && this.isSamePlayer(l, incomingPlayer);
                const isTarget = (targetStarter?.player_id || targetStarter?.player_name) && l.role === 'starting' && this.isSamePlayer(l, targetStarter);

                // CASE 1: Starter ↔ Starter (swap positions only)
                if (isIncoming && isTarget === false && incomingPlayer.role === 'starting' && targetStarter?.role === 'starting') {
                    return { ...l, position: position };
                }

                if (isTarget && incomingPlayer?.role === 'starting') {
                    return { ...l, position: incomingPlayer.position };
                }

                // CASE 2: Starter ↔ Substitute (swap role + position)
                if (isIncoming && incomingPlayer.role === 'substitute' && targetStarter?.role === 'starting' && (targetStarter?.player_id || targetStarter?.player_name)) {
                    return {
                        ...l,
                        role: 'starting',
                        position: targetStarter.position
                    };
                }

                if (isTarget && incomingPlayer.role === 'substitute') {
                    return {
                        ...l,
                        role: 'substitute',
                        position: null
                    };
                }

                // CASE 3: Substitute → Empty Slot
                if (isIncoming && incomingPlayer.role === 'substitute' && !targetStarter?.player_id) {
                    return {
                        ...l,
                        role: 'starting',
                        position: targetStarter.position
                    };
                }

                return l;
            });
        },
        choosePlayer(player) {
            if (!this.selectedTeam || this.selectedSlotIndex === null) return;

            this.swapIntoStartingSlot({
                team: this.selectedTeam,
                position: this.selectedSlot.position,
                slotIndex: this.selectedSlotIndex,
                incomingPlayer: player
            });

            this.balanceStarters(this.match.team_a, this.match.team_a_formation);

            this.currentModalView = 'select-player';
            this.search.criteria.eligiblePlayers.player_name = null
            this.selectedSlotIndex = null;
            this.selectedSlot = {};
            this.selectedTeam = null;
        },
        /* ===================================================
        * VALIDATION
        * =================================================== */
        validateLineup(team, formation) {
            const formationMap = this.buildFormationMap(formation);
            const starters = this.match.lineups.filter(
                l => l.team_id === team.id && l.role === 'starting'
            );
            if (starters.filter(p => p.position === 'goalkeeper').length !== 1) {
                return 'Un gardien de but est requis.';
            }
            for (const pos of this.formationPositions) {
                const required = formationMap[pos];
                const count = starters.filter(p => p.position === pos).length;
                if (count !== required) {
                    return `Il manque ${required - count} joueur(s) dans le poste ${this.startingPositions[pos]['abbr']}.`
                }
            }
            const ids = starters.map(p => p.player_id || p.player_name);
            if (new Set(ids).size !== ids.length) {
                return 'Titulaires en double détectés.';
            }
            return true;
        },
        /* ===================================================
        * SAVE
        * =================================================== */
        saveMatch() {
            const canEditA = this.canEditTeam(this.match.team_a);
            const canEditB = this.canEditTeam(this.match.team_b);
            let payload = {}
            if (!canEditA && !canEditB) {
                alert('You are not allowed to edit this match.');
                return;
            }
            if (canEditA) {
                const aValid = this.validateLineup(this.match.team_a, this.match.team_a_formation);
                if (aValid !== true) {
                    alert(aValid);
                    // return;
                }
                payload = {
                    team_a_formation: this.match.team_a_formation,
                    lineup: this.match.lineups.filter(l => l.team_id == this.match.team_a_id)
                }
            }
            if (canEditB) {
                const bValid = this.validateLineup(this.match.team_b, this.match.team_b_formation);
                if (bValid !== true) {
                    alert(bValid);
                    // return;
                }
                payload = {
                    team_b_formation: this.match.team_b_formation,
                    lineup: this.match.lineups.filter(l => l.team_id == this.match.team_b_id)
                }
            }

            api.post(`/private/matches/${this.id}`, payload)
                .then(() => {
                    alert('Formation sauvegardée avec succés.')
                    this.getMatch()
                });
        },
        /* ===================================================
        * HELPERS
        * =================================================== */
        isSamePlayer(a, b) {
            if (a.player_id && b.player_id) {
                return a.player_id === b.player_id;
            }
            return a.player_name === b.player_name;
        },
        formatDateTime(datetimeString) {
            if (!datetimeString) return "";
            const date = new Date(datetimeString);
            const formattedDate = date.toISOString().split("T")[0];
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            let date_obj = {
                date: formattedDate,
                time: `${hours}:${minutes}`,
                datetime: formattedDate + ` ${hours}:${minutes}`,
            };
            return date_obj;
        },
        formatTime(datetimeString) {
            if (!datetimeString) return ''
            const date = new Date(datetimeString)
            const hours = date.getHours().toString().padStart(2, '0')
            const minutes = date.getMinutes().toString().padStart(2, '0')
            return `${hours}:${minutes}`
        },
        goToPage(page, list='default') {
            if (list == 'default' && page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
            if (list == 'players' && page >= 1 && page <= this.totalPlayersPages) {
                this.currentPlayersPage = page;
            }
        },
        notStartedYet(match) {
            const booking = this.getReferenceBooking(match)
            if (!booking?.start_time) return false
            return this.formatDateTime(booking.start_time).datetime > moment().format('YYYY-MM-DD HH:mm')
        },
        hasMatchStarted(match) {
            const booking = this.getReferenceBooking(match)
            if (!booking?.start_time) return false
            return this.formatDateTime(booking.start_time).datetime <= moment().format('YYYY-MM-DD HH:mm')
        },
        getReferenceBooking(match) {
            if (match?.booking) return match.booking
            const suggestions = match?.suggestions || []
            const selected = suggestions.find(s => s.status === 'accepted') || suggestions.find(s => s.status === 'pending') || suggestions[0]
            return selected?.booking || null
        },
        getMatchCapacity(match) {
            const capacity = this.getReferenceBooking(match)?.slot?.facility?.capacity
            if (!capacity) return null
            return capacity / 2
        },
        displayFacilityName(match) {
            return this.getReferenceBooking(match)?.slot?.facility?.name || '-'
        },
        displayEstablishmentName(match) {
            return this.getReferenceBooking(match)?.slot?.facility?.establishment?.business_name || '-'
        },
        displayDelegation(match) {
            return this.getReferenceBooking(match)?.slot?.facility?.establishment?.delegation || '-'
        },
        generateFormations(totalPlayers) {
            const outfield = totalPlayers - 1; // exclude goalkeeper
            const formations = [];

            for (let d = 1; d <= outfield - 2; d++) {
                for (let m = 1; m <= outfield - d - 1; m++) {
                    const f = outfield - d - m;
                    if (f >= 1) {
                        formations.push(`${d}-${m}-${f}`);
                    }
                }
            }
            return formations;
        },
        isEmpty(obj) {
            return obj === '' || obj == [] || obj === null || obj === undefined || 
                (typeof obj === 'object' && Object.keys(obj).length === 0);
        },
    },
};
</script>
